module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/hiking@2x_b72709.jpg";